export const summaryText = (text, limit = 20) => (text.length > limit ? `${text.substr(0, limit)}...` : text)
export const nl2br = str => str.replace(/\n/g, '<br>')
